import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { packagenameList, delPackagename, disablePackagename } from "@/api/packagename";
import addpackagename from "./components/addpackagename";
import uploadImagetow from '@/components/uploadImagetow';
export default {
  name: "packagename",
  components: {
    addpackagename: addpackagename,
    uploadImagetow: uploadImagetow
  },
  data: function data() {
    return {
      tableData: [],
      addpackagename: false,
      total: 0,
      page: 1,
      showing: false,
      sels: [],
      selsString: '',
      searchData: {
        page: 1,
        page_size: 10,
        pkg_mark: '',
        pkg_name: ''
      },
      isLoading: false
    };
  },
  created: function created() {
    this.getData(1);
  },
  methods: {
    handleSource: function handleSource(id, num) {
      var _this = this;

      this.addpackagename = true;
      this.showing = true;
      this.$nextTick(function () {
        _this.$refs.addpackagename.init(id, num);
      });
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.getData(1);
    },
    getData: function getData(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.searchData.page = e;
                _this2.isLoading = true;
                packagenameList(_this2.searchData).then(function (res) {
                  if (res.status == 200) {
                    if (!res.data.data.length && e > 1) {
                      _this2.getData(e - 1);
                    } else {
                      _this2.tableData = res.data.data || [];
                      _this2.total = res.data.total || 0;
                    }
                  }
                }).finally(function () {
                  _this2.isLoading = false;
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this3 = this;

      this.sels = [];
      val.forEach(function (e) {
        _this3.sels.push(e.id);
      });
      this.selsString = this.sels.toString();
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    handleDisable: function handleDisable(id) {
      var _this4 = this;

      disablePackagename({
        id: id
      }).then(function (res) {
        if (res.status == 200) {
          Message({
            message: res.message,
            type: "success"
          });

          _this4.getData(_this4.searchData.page);
        }
      });
    },
    handleDelete: function handleDelete(id) {
      var _this5 = this;

      this.$confirm(this.$t('confirmDeleteData'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                delPackagename({
                  id: id
                }).then(function (res) {
                  _this5.getData(_this5.searchData.page);
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};